import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-service-section',
  imports: [RouterLink],
  templateUrl: './service-section.component.html',
  styleUrl: './service-section.component.css',
})
export class ServiceSectionComponent {

}
